import BaseUiNode from '../../framework/base-ui-node';
import Component  from '../../framework/component';
import BaseListPage from '../../framework/base-list-page';
import BaseModalViewer from '../../framework/modals/base-modal-viewer';
import ParameterizedPasswordModal from '../../framework/modals/parameterized-password-modal';
import DeleteConfirmationService from '../../framework/services/delete-confirmation-service';
import Page from './page';
import SplashScreen from './splash-screen';

globalThis.BaseUiNode   = BaseUiNode;
globalThis.Component    = Component;
globalThis.BaseListPage = BaseListPage;
globalThis.BaseModalViewer = BaseModalViewer;
globalThis.ParameterizedPasswordModal = ParameterizedPasswordModal;
globalThis.DeleteConfirmationService  = DeleteConfirmationService;
globalThis.Page         = Page;
globalThis.SplashScreen = SplashScreen;
